import { createContext, useContext, useEffect, useMemo, useReducer } from 'react';
import { baseSettingsHandlers, baseSettingsInitialState, baseSettingsReducer } from "../reducers/BaseSettingsReducer";
import { AppParentContext } from './AppParentContext';
import { DatabaseContext } from './DatabaseContext';
import { PapsContext } from './PapsContext';
import { HomeSettingsContext } from './SettingsDataContext';
import { useAppUserAccess } from './useHelpers/useAppUserAccess';
import { useBaseSettings } from './useHelpers/useBaseSettings';
import { useBaseSettingsArea } from './useHelpers/useBaseSettingsArea';

export const useAllSettingsFunctions = false
export const useSettingsCollection_get = true
export const useSettingsCollection_save = true

/** BaseSettingsProvider returns the default settings (from fsfn_functions) for the settings */
export const BaseSettingsContext = createContext();

/**
 *  BaseSettingsProvider returns the default settings (from fsfn_functions) for the settings
 * @param {object} props 
 * @returns - {hcceSettings, _baseSettings}
 */
const BaseSettingsProvider = (props) => {

  // appParentContext
  const appParentContext = useContext(AppParentContext);
  const { fn_cls } = appParentContext ?? {}

  // databaseContext
  const databaseContext = useContext(DatabaseContext)
  const { database_fns } = databaseContext ?? {}

  // appUserContext 
  const appUserAccess = useAppUserAccess()
  const { accessLevel, isDataAdmin } = appUserAccess ?? {}

  const aua = appUserAccess ? { uid: appUserAccess.uid, displayName: appUserAccess.displayName } : { uid: 0, displayName: 'Unknown' }

  // papsContext 
  const papsContext = useContext(PapsContext)
  const { paps_state } = papsContext ?? {}
  const { appArea, pathViews } = paps_state ?? {}

  // homeSettingsContext
  const homeSettingsContext = useContext(HomeSettingsContext);
  const { homeSettings_state } = homeSettingsContext ?? {}
  const { homeSettings } = homeSettings_state ?? {}
  const { global } = homeSettings ?? {}
  const { settingsConsole: settingsConsole_home_global } = global ?? {}

  // const init_state = { fn_cls, database_fns, accessLevel, settingsConsole_home_global, aua, pathViews }
  const init_state = { accessLevel, settingsConsole_home_global, aua, pathViews }
  const [baseSettings_state, baseSettingsDispatch] = useReducer(baseSettingsReducer, baseSettingsInitialState(init_state));

  const baseSettings_handlers = useMemo(
    () => baseSettingsHandlers(baseSettingsDispatch),
    [baseSettingsDispatch]
  );

  const { baseSettingsApp: bsa } = useBaseSettings()
  const { baseSettingsArea } = useBaseSettingsArea({ bsa })

  useEffect(() => {
    if (bsa) {
      baseSettings_handlers.handleSet_baseSettingsApp(bsa)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [bsa]);

  useEffect(() => {
    if (appArea && baseSettingsArea) {
      baseSettings_handlers.handleSet_baseSettingsAppArea(appArea, baseSettingsArea)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [appArea, baseSettingsArea]);

  const providerContext = () => <BaseSettingsContext.Provider value={{ baseSettings_state, baseSettings_handlers }}>
    {props.children}
  </BaseSettingsContext.Provider>

  return providerContext()

}

export default BaseSettingsProvider